// extracted by mini-css-extract-plugin
module.exports = {"containerCountChild":"Counters_containerCountChild__EWoY5","counter":"Counters_counter__10_Dh","parenthesis":"Counters_parenthesis__1YE9i"};